export const PRODUCT_DESCRIPTION = {
    BUNDLE_DESCRIPTION: {
        CODE: 'bundleDescription',
    },
    COMMENTS: {
        CODE: 'comments',
    },
    DEGUSTATION_CHARACTERISTICS: {
        CODE: 'degustationCharacteristics',
    },
    DESCRIPTION: {
        CODE: 'description',
    },
    GASTRONOMY: {
        CODE: 'gastronomy',
    },
    GRAPES_DESC: {
        CODE: 'grapesDesc',
    },
    HISTORY_LABELS: {
        CODE: 'historyLabels',
    },
    ITS_INTERESTING: {
        CODE: 'itsInteresting',
    },
    METHOD_AGING: {
        CODE: 'methodAging',
    },
    METHOD_PRODUCTION: {
        CODE: 'methodProduction',
    },
    SET_DESCRIPTION: {
        CODE: 'setDescription',
    },
    STYLEWINE: {
        CODE: 'styleWine',
    },
    SUITABLE: {
        CODE: 'suitable',
    },
};

export interface IProductDescriptionListCommonItem {
    CODE: string;
}

export type TProductDescriptionListCommon = IProductDescriptionListCommonItem[];

export const PRODUCT_DESCRIPTION_LIST_COMMON: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.GASTRONOMY,
    PRODUCT_DESCRIPTION.STYLEWINE,
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.GRAPES_DESC,
    PRODUCT_DESCRIPTION.METHOD_AGING,
    PRODUCT_DESCRIPTION.METHOD_PRODUCTION,
    PRODUCT_DESCRIPTION.HISTORY_LABELS,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
    PRODUCT_DESCRIPTION.DESCRIPTION,
    PRODUCT_DESCRIPTION.SET_DESCRIPTION,
    PRODUCT_DESCRIPTION.BUNDLE_DESCRIPTION,
    PRODUCT_DESCRIPTION.COMMENTS,
];

export const PRODUCT_DESCRIPTION_LIST_VINO: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.GASTRONOMY,
    PRODUCT_DESCRIPTION.STYLEWINE,
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.GRAPES_DESC,
    PRODUCT_DESCRIPTION.METHOD_AGING,
    PRODUCT_DESCRIPTION.METHOD_PRODUCTION,
    PRODUCT_DESCRIPTION.SET_DESCRIPTION,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_FINE_AND_RARE: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.STYLEWINE,
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.GRAPES_DESC,
    PRODUCT_DESCRIPTION.METHOD_AGING,
    PRODUCT_DESCRIPTION.METHOD_PRODUCTION,
    PRODUCT_DESCRIPTION.SET_DESCRIPTION,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_KSN: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.GASTRONOMY,
    PRODUCT_DESCRIPTION.METHOD_AGING,
    PRODUCT_DESCRIPTION.METHOD_PRODUCTION,
    PRODUCT_DESCRIPTION.SET_DESCRIPTION,
    PRODUCT_DESCRIPTION.HISTORY_LABELS,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_VODA: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_SHAMPANSKOE: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.GASTRONOMY,
    PRODUCT_DESCRIPTION.STYLEWINE,
    PRODUCT_DESCRIPTION.DEGUSTATION_CHARACTERISTICS,
    PRODUCT_DESCRIPTION.GRAPES_DESC,
    PRODUCT_DESCRIPTION.METHOD_AGING,
    PRODUCT_DESCRIPTION.METHOD_PRODUCTION,
    PRODUCT_DESCRIPTION.SET_DESCRIPTION,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_BOKALI: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.SUITABLE,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];

export const PRODUCT_DESCRIPTION_LIST_ACCESSORIES: TProductDescriptionListCommon = [
    PRODUCT_DESCRIPTION.SUITABLE,
    PRODUCT_DESCRIPTION.DESCRIPTION,
    PRODUCT_DESCRIPTION.ITS_INTERESTING,
];
